import { httpClient } from '@bcba/client-auth';
import { CommonUpsertStorageFacilityDto } from '../types/query-params';

export const upsertStorageFacility = async (
  data: CommonUpsertStorageFacilityDto,
) => {
  return httpClient.put('/storage-facilities', data);
};
